import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { initI18n } from "./i18n";
import "./styles/index.css";

const rootEl = document.getElementById("root");
if (!rootEl) {
  throw new Error("Root element #root not found in index.html");
}

// Top-level await: render only after i18n is ready, so the first paint
// is in the right language (no English → Chinese snap after the
// `tb` install card is already on screen). Vite supports top-level
// await in entry modules out of the box.
const root = createRoot(rootEl);
root.render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
);

// React 19 will not re-render automatically when i18next finishes its
// async `changeLanguage` from the navigator fallback. We schedule a
// re-render after init() resolves so the UI snaps to the right locale.
initI18n().then(() => {
  // Force a fresh render so any `t(...)` calls that ran during the
  // initial paint (with i18n still on the fallback locale) get re-evaluated.
  root.render(
    <StrictMode>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </StrictMode>,
  );
});
